export const ACADEMY_PROJECT_MODAL_STAGES = {
  notOpen: 'notOpen',
  create: 'create',
  details: 'details',
};
